export const environment = {
    production: false,
    apiUrl: 'https://adminapi.kokoro.guru',
    homeCareApiUrl: 'https://care.kokoro.guru/api/v1',
    apiStoreUrl: 'https://store.kokoro.guru/api/v1',
    ticketApiUrl: 'https://ticket.kokoro.guru/api/v1',
    doctorApiUrl: 'https://kokorodoctor.kokoro.guru/',
    // Deployed and confirmed healthy on guru 2026-09-03.
    careCompanionApiUrl: 'https://services.kokoro.guru/api/v1',
    userApiUrl: 'https://kokorouser.kokoro.guru',
    insuranceApiUrl: 'https://insurecore.kokoro.guru/api/v1',
    productMatchingApiUrl: 'https://prdes.kokoro.guru/api/v1',
    googleMapsApiKey: 'AIzaSyCI_mpTR5O10P4ZT6Qzz3OHVB--G6uKHsE',
    membershipBaseUrl: 'https://kokoro.guru',
    notificationApiUrl: 'https://kokoro.guru/api/v1/notification',
};
